'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-13d783d6.js');
var React = require('react');

var Beratung = function (_a) {
    var className = _a.className, restProps = tslib_es6.__rest(_a, ["className"]);
    return (React.createElement("div", { className: className },
        React.createElement("svg", tslib_es6.__assign({ width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, restProps),
            React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd", fill: "#323232" },
                React.createElement("path", { d: "M22.5 22.5V36H24V24h9v4.401l1.5-1.492V22.5h-12ZM27.518 36l12.844-12.844 8.485 8.486L44.49 36h-2.12l4.356-4.358-6.364-6.364L29.634 36h-2.116ZM49.5 37.5h-27v12h27v-12ZM48 39H24v9h24v-9Z" }),
                React.createElement("path", { d: "M28.5 46.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })))));
};

exports.default = Beratung;
//# sourceMappingURL=index.js.map
